import Vue from "vue";
import Router from "vue-router";
import store from "./store";

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/dashboard",
      alias: "/",
      name: "dashboard",
      component: () => import("./views/Dashboard.vue"),
      meta: {
        requiresAuth: true,
        title: "Seabid - Dashboard",
      },
    },
    {
      path: "/auction/:id",
      alias: "/",
      name: "auction",
      component: () => import("./views/Auction.vue"),
      meta: {
        requiresAuth: true,
        title: "Seabid - Auction Details",
      },
    },
    {
      path: "/login",
      alias: "/",
      name: "login",
      component: () => import("./views/Login.vue"),
      meta: {
        requiresAuth: false,
        title: "Seabid - Login",
      },
    },
    {
      path: "/sso",
      name: "sso",
      component: () => import("./views/SSO.vue"),
      meta: {
        requiresAuth: false,
        title: "Seabid - Signing in...",
      },
    },
    {
      path: "/settings",
      name: "settings",
      component: () => import("./views/Settings.vue"),
      meta: {
        requiresAuth: true,
        title: "Seabid - Settings",
      },
    },
    {
      path: "*",
      redirect: "/login",
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (to.name == "sso") {
    var isAuth = await store.dispatch("authenticate", false);
    if (isAuth) {
      next("dashboard");
    } else {
      next();
    }
    return;
  }

  if (to.query.e) {
    store.commit("setRedirectOnLogin", to.params.id);
  }
  if (to.name == "login" && to.params.redirect) {
    next();
  } else {
    var isAuth = await store.dispatch("authenticate");
    document.title = to.meta.title;
    if (from.name == "settings" && store.state.unsavedSettingChanges) {
      var canContinue = window.confirm("Are you sure you want to leave? You have unsaved changes.");
      if (!canContinue) {
        next(false);
      } else {
        next();
      }
    } else {
      if (to.meta.requiresAuth) {
        if (!isAuth) {
          if (to.query.create && to.name == "dashboard") {
            store.commit("setAuctionToBeCreated", to.query.create);
          }
          next({
            path: "/login",
            params: {
              redirect: true,
            },
          });
        } else {
          if (to.name == "dashboard" && store.state.redirectToAuctionOnLogin) {
            next(`/auction/${store.state.redirectToAuctionOnLogin}`);
            store.commit("setRedirectOnLogin", null);
          } else {
            next();
          }
        }
      } else {
        if (to.name == "login" && isAuth && !to.params.redirect) {
          next({
            path: "/dashboard",
            params: {
              redirect: false,
            },
          });
        } else {
          next();
        }
      }
    }
  }
});

export default router;
